// components/Dashboard.jsx
import React, { useState } from "react";
import Sidebar from "../../components/Sidebar";
import MainContent from "../../components/MainContent";

const Dashboard = () => {
  const [activeSection, setActiveSection] = useState("trainings");

  const sections = [
    { id: "trainings", name: "Trainings", available: true },
    { id: "continues-trainings", name: "Continues Trainings", available: true },
    { id: "books", name: "Books", available: true },
    { id: "library-categories", name: "Library Categories", available: true },
    { id: "media", name: "Media", available: true },
    { id: "news", name: "News", available: true },
    { id: "publications", name: "Publications", available: true },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100" dir="ltr">
      <div className="flex h-screen bg-gray-50">
        <Sidebar
          sections={sections}
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
        <MainContent activeSection={activeSection} sections={sections} />
      </div>
    </div>
  );
};

export default Dashboard;
